/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Russian
export default {
  'ai-floating-context-menu.ai-dynamic-surface.back': 'назад',
  'ai-floating-context-menu.ai-dynamic-surface.referencing-panel-title': 'Ссылки',
  'ai-floating-context-menu.ai-dynamic-surface.rovo-panel-title': 'Rovo',
  'ai-smart-button.ai-actions.actions.section.text': 'Действия',
  'ai-smart-button.ai-actions.conversation-starters.section.text': 'Задайте вопрос Rovo',
  'ai-smart-button.ai-actions.give-feedback-action.title': 'Оставить отзыв',
  'ai-smart-button.ai-actions.help.section.text': 'Справка',
  'ai-smart-button.ai-actions.input.link-picker-button-label': 'Ссылка',
  'ai-smart-button.ai-actions.input.mention-button-label': 'Упоминание',
  'ai-smart-button.ai-actions.input.placeholder': 'Введите запрос',
  'ai-smart-button.ai-actions.input.send-button-label': 'Отправить',
  'ai-smart-button.ai-actions.item.betaLozenge': 'БЕТА-ВЕРСИЯ',
  'ai-smart-button.ai-actions.item.newLozenge': 'НОВОЕ',
  'ai-smart-button.ai-actions.no-results-heading': 'Задайте вопрос Rovo',
  'ai-smart-button.ai-actions.no-results-text': 'Отправьте запрос в Rovo, чтобы начать чат.',
  'ai-smart-button.ai-actions.rovo-agents.add-icon-label': 'Добавить значок',
  'ai-smart-button.ai-actions.rovo-agents.agent-icon-label': 'Значок агента',
  'ai-smart-button.ai-actions.rovo-agents.automation-icon-label': 'Значок автоматизации',
  'ai-smart-button.ai-actions.rovo-agents.automations.text': 'Автоматизация',
  'ai-smart-button.ai-actions.rovo-agents.browse-agent.text': 'Просмотреть агентов',
  'ai-smart-button.ai-actions.rovo-agents.create-agent.text': 'Создать агента',
  'ai-smart-button.ai-actions.rovo-agents.create-automation.text': 'Создать автоматизацию',
  'ai-smart-button.ai-actions.rovo-agents.section.text': 'Мастерская',
  'ai-smart-button.ai-dynamic-surface.components.greeting.intro-second-line': 'Чем я могу помочь?',
  'ai-smart-button.ai-dynamic-surface.components.greeting.intro-text-headline': 'Здравствуйте, {name}!',
  'ai-smart-button.ai-proactive-nudge.dismiss': 'Закрыть',
  'ai-smart-button.feedback-action.ask-question-option': 'Задать вопрос',
  'ai-smart-button.feedback-action.can-contact-message':
    'Да, команды {product} могут связаться со мной, чтобы узнать о моих впечатлениях и использовать эту информацию для улучшения продуктов и услуг Atlassian. Я принимаю {privacyPolicy}',
  'ai-smart-button.feedback-action.cancel-button-label': 'Отмена',
  'ai-smart-button.feedback-action.choose-feedback-option': 'Выберите отзыв',
  'ai-smart-button.feedback-action.feedback-entry-bug-heading': 'Опишите баг или проблему',
  'ai-smart-button.feedback-action.feedback-entry-comment-heading': 'Поделитесь своими мыслями',
  'ai-smart-button.feedback-action.feedback-entry-question-heading': 'О чем бы вы хотели знать?',
  'ai-smart-button.feedback-action.feedback-entry-suggest-heading': 'Расскажите, что бы вы хотели улучшить',
  'ai-smart-button.feedback-action.leave-comment-option': 'Оставить комментарий',
  'ai-smart-button.feedback-action.privacy-policy-link': 'Политику конфиденциальности {product}.',
  'ai-smart-button.feedback-action.report-bug-option': 'Сообщить о баге',
  'ai-smart-button.feedback-action.research-participation-message': 'Я хочу принять участие в исследовании продукта',
  'ai-smart-button.feedback-action.select-feedback-heading': 'Выберите отзыв',
  'ai-smart-button.feedback-action.submit-button-label': 'Отправить отзыв',
  'ai-smart-button.feedback-action.suggest-improvement-option': 'Предложить улучшение',
  'ai-smart-button.feedback-action.title': 'Оставить отзыв',
  'ai-smart-button.feedback-item.icon-label': 'Значок обратной связи',
  'ai-smart-button.reference.close-button-label': 'Закрыть',
  'quick-summary.feedback.summary.placeholder':
    'С чем функции Atlassian Intelligence справились хорошо? Есть ли аспекты, которые можно улучшить?',
  'quick-summary.feedback.title': 'Помогите улучшить Atlassian Intelligence',
};
